"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retry = void 0;
const axios_1 = __importDefault(require("axios"));
var Retry;
(function (Retry) {
    async function promise(func, retries = 3) {
        let error = new Error();
        for (let i = 0; i < retries; i++) {
            try {
                return await func();
            }
            catch (err) {
                error = err;
            }
        }
        throw error;
    }
    Retry.promise = promise;
    async function fetch(url, opts = { retries: 3 }) {
        return promise(async () => await (0, axios_1.default)(url.toString(), opts), opts.retries);
    }
    Retry.fetch = fetch;
    async function fetchJSON(url, opts = { retries: 3 }) {
        return fetch(url, opts).then(res => res.data);
    }
    Retry.fetchJSON = fetchJSON;
})(Retry = exports.Retry || (exports.Retry = {}));
